module.exports = __webpack_public_path__ + "img/img_61284_0_5.3fa8cc2f.png";